import draftShopperData from './draft-shopper-data';
import notifications from './notifications';
import { get } from './global';

// Create a frozen shallow copy of window.ux.data
const _data = get('window', 'ux.data');
const data = _data && Object.freeze({ ..._data });

// Expose the Shopper Data API
const shopperData = get('window', 'ux.eldorado.shopperData');

export {
  data,
  shopperData,
  draftShopperData,
  notifications
};
